import { AlkLogger } from '@alk/core';
import { DATA } from '../../mocks/app-branding-config.data';
import { HTTP_SERVICE, IHttpService } from '../http';
import { IAppBrandingConfig } from '../../interfaces';
import { IAppBrandingConfigService } from './app-branding-config.interface';
import { inject, injectable } from 'inversify';

const PATH = '/shared/brand-config.json';

@injectable()
export class AppBrandingConfigService implements IAppBrandingConfigService {

    @inject(HTTP_SERVICE) private readonly httpSrv: IHttpService;

    private configPromise: Promise<IAppBrandingConfig>;

    async get(): Promise<IAppBrandingConfig> {
        if (Boolean(this.configPromise)) {
            return this.configPromise;
        }

        this.configPromise = this.httpSrv.get<IAppBrandingConfig>(PATH)
            .then(([ config, error ]) => {
                if (Boolean(error)) {
                    AlkLogger.error([
                        '[AppBrandingConfigService#get] Unable to get the custom branding config',
                        `filefrom the config folder (${ error.code } ${ error.message })!`,
                        'Fallback on the default branding config file.',
                    ].join(' '));

                    return DATA;
                } else {
                    return config;
                }
            });

        return this.configPromise;
    }
}
